import { TicketData } from '@/common/types/support/ticket.type';
import { formatDateTime } from '@/common/utils/formatters';
import { SupportTicketCreator } from '@/features/support/external/components/SupportTicketCreator';
import { SupportTicketStatus } from '@/features/support/external/components/SupportTicketStatus';
import { ArrowBigRightIcon, UserRoundIcon } from 'lucide-react';
import { createElement } from 'react';
import { Link } from 'react-router-dom';
import { strategy as statusStrategy } from '@/features/support/external/constants/statusOptions.constant';
import Button from '@/common/components/Button';
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName';
import ButtonLink from '@/common/components/ButtonLink';

export class ExternalSupportTicketsTransformer {
  static tableTransformer() {
    return (supportTickets: TicketData[]) => {
      return supportTickets.map((supportTicket) => ({
        _className: supportTicket.status === 'awaiting_tcard_response' && 'bg-yellow-op-2',
        reference_number: supportTicket.reference_number,
        status: supportTicket.status ? createElement(SupportTicketStatus, { status: supportTicket.status }) : '',
        reason: supportTicket.reason.display_name || '',
        subject_line: supportTicket.subject_line || '',
        company_last_viewed_at: supportTicket?.company_last_viewed_at ? formatDateTime(new Date(supportTicket?.company_last_viewed_at)) : '--',
        responsible: supportTicket.responsible ? (
          <ButtonLink
            linkTo={`/users/${supportTicket?.responsible?.id}`}
            operationKlassToCheckPermission='Admin::Users::Show'
            dataTestId="creator_clickable_link"
          >
            <ImageWithDisplayName
              placeholderIcon={UserRoundIcon}
              imageUrl={supportTicket.responsible?.profile_picture?.url}
              displayName={supportTicket.responsible?.full_name}
            />
          </ButtonLink>
        ) : '--',
        creator: supportTicket.creator ? createElement(SupportTicketCreator, { creator: supportTicket.creator, branch: supportTicket.branch }) : '',
        created_at: supportTicket.created_at ? formatDateTime(new Date(supportTicket.created_at)) : '',
        actions: (
          <Link to={`/external-support/${supportTicket.id}`}>
            <Button
              className="bg-transparent hover:bg-transparent p-0"
              operationKlassToCheckPermission="Admin::Support::Tickets::Show"
            >
              <ArrowBigRightIcon />
            </Button>
          </Link>
        ),
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (supportTickets: TicketData[]) => {
      return supportTickets.map((supportTicket) => ({
        route: `/external-support/${supportTicket.id}`,
        items: [
          ['Código', supportTicket.reference_number],
          ['Status', supportTicket.status ? statusStrategy[supportTicket.status as keyof typeof statusStrategy] : ''],
          ['Motivo', supportTicket.reason.display_name],
          ['Assunto', supportTicket.subject_line],
          ['Autor', `${supportTicket.creator.full_name} (${supportTicket.creator?.company?.general_information?.fantasy_name})`],
        ]
      }));
    };
  }
}
